import ProcessingFeesTable from './ProcessingFeesTable';
export default ProcessingFeesTable;
